import { api } from "./api";

export class TrackerTypeService {
  async post(value: string) {
    try {
      const response = await api.post(`/tracker-type`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async get() {
    try {
      const response = await api.get(`/tracker-type`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getById(id: string) {
    try {
      const response = await api.get(`/tracker-type/${id}`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async patch(value: string, id: string) {
    try {
      const response = await api.patch(`/tracker-type/${id}`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async delete(id: string) {
    try {
      const response = await api.delete(`/tracker-type/${id}`);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }
}
